import ReactDOM from 'react-dom';
import { xs_isMobile } from "../..";
import { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';

export default function BetslipLoaderWrapper(props) {
    const betslipContext = useContext(BetslipContext);
    const showOverlay = betslipContext.getLoaderData().type !== 'hideAll';

    if (xs_isMobile && showOverlay) {
        const container = document.getElementById('betslip-overlay-container');
        return ReactDOM.createPortal(
            <div className="betslip-loader-container">
                {props.element}
            </div>,
            container
        );
    }
    return props.element;
}
